<div *ngIf="isPhoneNumberVerified; else notVerified">
	<span class="ico-checkmark-circle-outline"></span>
	<span>{{ 'verification.verified-successfully' | translate }}</span>
</div>
<ng-template #notVerified>
	<form novalidate [formGroup]="phoneNumberFormGroup" (ngSubmit)="submitPhoneNumberForm()">
		<div class="obg-m-phone-verification-description">
			<small>{{ 'verification.label-phone' | translate }}</small>
		</div>

		<div class="obg-m-phone-verification-first-column">
			<mat-form-field>
				<mat-select
					test-id="verify-phone-extension"
					formControlName="phoneExtension"
					placeholder="{{ 'register.country-calling-code' | translate }}"
				>
					<mat-option
						*ngFor="let callingCode of callingCodes; trackBy: callingCodeTrackBy"
						value="{{ callingCode }}"
						>+{{ callingCode }}</mat-option
					>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="obg-m-phone-verification-second-column">
			<mat-form-field>
				<input
					matInput
					type="tel"
					formControlName="phoneNumber"
					test-id="verify-phone-number"
					placeholder="{{ 'register.phone' | translate }}"
				/>
				<obg-common-validation-renderer
					[input]="phoneNumberFormGroup?.controls.phoneNumber"
					[translationPrefix]="'register.phone-number'"
				>
				</obg-common-validation-renderer>
			</mat-form-field>
		</div>

		<button
			type="submit"
			color="primary"
			mat-flat-button
			[disabled]="!phoneNumberFormGroup?.valid"
			test-id="verification-send-code-button"
		>
			{{ 'verification.send-code' | translate }}
		</button>
	</form>

	<form
		novalidate
		class="obg-m-phone-verification-verify-form"
		[formGroup]="verifyCodeFormGroup"
		(ngSubmit)="submitVerifyForm()"
	>
		<mat-form-field>
			<input
				matInput
				type="tel"
				formControlName="verificationCode"
				placeholder="{{ 'verification.placeholder-code' | translate }}"
			/>
		</mat-form-field>
		<obg-common-validation-renderer
			[input]="verifyCodeFormGroup?.controls.verificationCode"
			[translationPrefix]="'verification.code'"
		>
		</obg-common-validation-renderer>

		<button
			type="submit"
			color="primary"
			mat-flat-button
			test-id="verification-verify-code-button"
			[disabled]="!verifyCodeFormGroup?.valid"
		>
			{{ 'verification.verify-code' | translate }}
		</button>
	</form>
</ng-template>
